
import { cn } from "@/lib/imports";
import { motion } from "framer-motion";
import { Label } from "../ui/label";

interface Props {
  className?: string;
}

export const Footer: React.FC<Props> = ({ className }) => {
  return (
    <motion.footer
      initial={{ opacity: 0}}
      animate={{ opacity: 1}}
      transition={{ duration: 0.6}}
      className={cn("h-22 flex items-center w-full absolute bottom-0 max-md:hidden", className)}
    >
      <Label className="flex w-full justify-start text-sm font-light opacity-30">
        © {new Date().getFullYear()} Max Kononchuk. All rights reserved.
      </Label>
    </motion.footer>
  );
};

export default Footer;
